import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NewChip from 'app/components/NewChip';

interface Props {
  title: string;
  description: string;
  note: string;
}

const PromoCallout: FC<Props> = ({ title, description, note }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: 'promo.calloutBackground',
        border: '1px solid',
        borderColor: 'promo.calloutBorder',
        borderRadius: '8px',
        padding: '16px',
      }}
    >
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: '12px', mb: '4px' }}
      >
        <NewChip />
        <Typography
          component="div"
          sx={{
            fontWeight: 700,
            color: 'primary.darker',
            fontSize: '16px',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Typography
        component="div"
        sx={{
          fontStyle: 'italic',
          fontSize: '14px',
          color: 'grey.900',
          mb: '4px',
        }}
      >
        {description}
      </Typography>
      <Typography
        component="div"
        sx={{
          fontStyle: 'italic',
          fontSize: '12px',
          color: 'secondary.darker',
        }}
      >
        {note}
      </Typography>
    </Box>
  );
};

export default PromoCallout;
